const automobiles = [
    {
        id: 2,
        slug: "kia-seltos",
        name: "KIA SELTOS",

        shortDescription:
            "Premium SUV with luxury comfort and smart technology.",

        image: "/assets/img/Automobiles/seltos_05.png",

        description:
            "The Kia Seltos is a premium SUV that combines bold styling, advanced technology, powerful performance, and exceptional comfort. Designed for families and adventure seekers, it offers a refined driving experience with modern safety features and intelligent connectivity.",

        specifications: {
            Brand: "KIA",
            Model: "Seltos",
            BodyType: "Premium SUV",
            Engine: "1.5L Petrol",
            Transmission: "Automatic",
            DriveType: "Front Wheel Drive",
            Power: "115 PS",
            Torque: "144 Nm",
            TopSpeed: "170 km/h",
            FuelType: "Petrol",
            FuelTank: "50 L",
            Mileage: "17-19 km/l",
            Seating: "5 Seater",
            Doors: "5",
            Wheels: "17-inch Alloy Wheels",
            GroundClearance: "190 mm",
            AirConditioning: "Automatic Climate Control"
        },

        exterior: [
            "Tiger Nose Front Grille",
            "Full LED Headlamps",
            "LED DRLs",
            "LED Tail Lamps",
            "Front & Rear Skid Plates",
            "Panoramic Sunroof",
            "Roof Rails",
            "Shark Fin Antenna",
            "Chrome Door Handles",
            "Electric ORVM",
            "17-inch Diamond Cut Alloy Wheels",
            "Rear Spoiler",
            "Rear Wiper",
            "Rear Defogger",
            "Dual Tone Exterior"
        ],

        interior: [
            "Premium Leather Upholstery",
            "Ventilated Front Seats",
            "10.25-inch Touchscreen Display",
            "Digital Instrument Cluster",
            "BOSE Premium Sound System",
            "Wireless Phone Charger",
            "Ambient Mood Lighting",
            "Automatic Climate Control",
            "Rear AC Vents",
            "Leather Steering Wheel",
            "Push Button Start",
            "Smart Key",
            "Electric Sunroof Controls",
            "60:40 Split Rear Seats",
            "Adjustable Driver Seat"
        ],

        performance: [
            "1.5L Smart Petrol Engine",
            "Automatic Transmission",
            "Excellent Fuel Economy",
            "Smooth Suspension",
            "Comfortable Highway Ride",
            "Responsive Steering",
            "Drive Modes",
            "Powerful Acceleration",
            "Stable Cornering",
            "Low Cabin Noise"
        ],

        technology: [
            "Apple CarPlay",
            "Android Auto",
            "Navigation System",
            "Bluetooth",
            "USB Connectivity",
            "Wireless Charging",
            "BOSE Premium Audio",
            "Voice Commands",
            "Steering Mounted Controls",
            "360 Degree Camera",
            "Cruise Control",
            "Digital MID Display"
        ],

        safety: [
            "6 Airbags",
            "ABS",
            "Electronic Stability Control",
            "Hill Assist Control",
            "Traction Control",
            "Tyre Pressure Monitoring System",
            "360 Degree Camera",
            "Front Parking Sensors",
            "Rear Parking Sensors",
            "ISOFIX Child Seat Anchors",
            "Child Safety Locks",
            "Seat Belt Reminder",
            "Emergency Stop Signal",
            "Engine Immobilizer",
            "Central Locking"
        ],

        features: [
            "Panoramic Sunroof",
            "LED Headlamps",
            "LED DRLs",
            "BOSE Premium Audio",
            "Wireless Charger",
            "Apple CarPlay",
            "Android Auto",
            "Leather Seats",
            "Ventilated Seats",
            "360 Degree Camera",
            "Cruise Control",
            "Digital Cluster",
            "Automatic Climate Control",
            "Rear AC Vents",
            "Push Button Start",
            "Smart Key",
            "ABS + ESC",
            "6 Airbags"
        ],

        gallery: [
            "/assets/img/Automobiles/KIA-SELTOS/seltos_05.png",
            "/assets/img/Automobiles/KIA-SELTOS/seltos_06.png",
            "/assets/img/Automobiles/KIA-SELTOS/seltos_07.png",
            "/assets/img/Automobiles/KIA-SELTOS/seltos_09.png",
            "/assets/img/Automobiles/KIA-SELTOS/seltos_01.png",
            "/assets/img/Automobiles/KIA-SELTOS/seltos_02.png",
            "/assets/img/Automobiles/KIA-SELTOS/seltos_03.png",
            "/assets/img/Automobiles/KIA-SELTOS/seltos_04.png",
            // "/assets/img/Automobiles/KIA-SELTOS/seltos_08.png",
            "/assets/img/Automobiles/KIA-SELTOS/seltos_main_image.png",
        ]
    },

    {
        id: 3,
        slug: "kia-k3",
        name: "KIA K3",

        shortDescription:
            "Premium sedan with sporty design and advanced technology.",

        image: "/assets/img/Automobiles/KIA-K3.jpg",

        description:
            "The Kia K3 is a premium sedan that blends sporty styling, modern technology, refined comfort, and excellent performance. It is designed for customers looking for elegance, efficiency, and advanced safety features in a stylish package.",

        specifications: {
            Brand: "KIA",
            Model: "K3",
            BodyType: "Premium Sedan",
            Engine: "1.5L Petrol",
            Transmission: "Automatic",
            DriveType: "Front Wheel Drive",
            Power: "115 PS",
            Torque: "144 Nm",
            TopSpeed: "190 km/h",
            FuelType: "Petrol",
            FuelTank: "50 L",
            Mileage: "18-20 km/l",
            Seating: "5 Seater",
            Doors: "4",
            Wheels: "17-inch Alloy Wheels",
            GroundClearance: "160 mm",
            AirConditioning: "Automatic Climate Control"
        },

        exterior: [
            "Tiger Nose Front Grille",
            "LED Headlights",
            "LED Daytime Running Lights",
            "LED Tail Lamps",
            "Chrome Window Garnish",
            "17-inch Alloy Wheels",
            "Electric Sunroof",
            "Body Colored Mirrors",
            "Power Folding ORVM",
            "Shark Fin Antenna",
            "Rear Defogger",
            "Rear Parking Camera"
        ],

        interior: [
            "Premium Leather Seats",
            "Leather Wrapped Steering",
            "10.25-inch Touchscreen",
            "Digital Instrument Cluster",
            "Automatic Climate Control",
            "Wireless Phone Charger",
            "Push Button Start",
            "Smart Key",
            "Rear AC Vents",
            "Ambient Interior Lighting",
            "60:40 Split Rear Seats",
            "Premium Dashboard Finish"
        ],

        performance: [
            "1.5L Smart Petrol Engine",
            "Automatic Transmission",
            "Smooth Highway Performance",
            "Comfortable City Driving",
            "Excellent Fuel Efficiency",
            "Responsive Steering",
            "Low Cabin Noise",
            "Stable Suspension",
            "Eco Driving Mode"
        ],

        technology: [
            "Apple CarPlay",
            "Android Auto",
            "Bluetooth Connectivity",
            "USB Charging",
            "Wireless Phone Charger",
            "Voice Commands",
            "Navigation",
            "Steering Mounted Controls",
            "Digital MID",
            "Rear Camera"
        ],

        safety: [
            "6 Airbags",
            "ABS",
            "Electronic Stability Control",
            "Traction Control",
            "Hill Assist",
            "Rear Parking Sensors",
            "Rear View Camera",
            "Tyre Pressure Monitoring System",
            "ISOFIX Child Seat Mount",
            "Central Locking",
            "Child Safety Lock",
            "Engine Immobilizer"
        ],

        features: [
            "LED Headlights",
            "Sunroof",
            "Leather Seats",
            "Digital Cluster",
            "Wireless Charger",
            "Apple CarPlay",
            "Android Auto",
            "Rear Camera",
            "Cruise Control",
            "Automatic Climate Control",
            "Premium Sound System",
            "Push Button Start",
            "Smart Key",
            "ABS + ESC",
            "6 Airbags"
        ],

        gallery: [
            "/assets/img/Automobiles/KIA-K3/2.avif",
            "/assets/img/Automobiles/KIA-K3/9.avif",
            "/assets/img/Automobiles/KIA-K3/1.avif",
            "/assets/img/Automobiles/KIA-K3/3.avif",
            "/assets/img/Automobiles/KIA-K3/4.avif",
            "/assets/img/Automobiles/KIA-K3/5.avif",
            "/assets/img/Automobiles/KIA-K3/6.avif",
            "/assets/img/Automobiles/KIA-K3/7.avif",
            "/assets/img/Automobiles/KIA-K3/8.avif",
            "/assets/img/Automobiles/KIA-K3/10.avif",
            "/assets/img/Automobiles/KIA-K3/11.avif",
            "/assets/img/Automobiles/KIA-K3/12.avif",
            "/assets/img/Automobiles/KIA-K3/13.avif",
            "/assets/img/Automobiles/KIA-K3/14.avif",
            "/assets/img/Automobiles/KIA-K3/15.avif",
            "/assets/img/Automobiles/KIA-K3/16.avif",
            "/assets/img/Automobiles/KIA-K3/17.avif",
            "/assets/img/Automobiles/KIA-K3/18.avif",
            "/assets/img/Automobiles/KIA-K3/19.avif",
            "/assets/img/Automobiles/KIA-K3/20.avif",
        ]
    },

    {
        id: 1,
        slug: "kia-kx1",
        name: "KIA KX1",

        shortDescription:
            "Compact SUV with modern styling and advanced features.",

        image: "/assets/img/Automobiles/Kia-KX1.jpg",

        description:
            "The Kia KX1 is a stylish compact SUV that combines modern design, excellent fuel efficiency, advanced safety, and premium comfort. It is designed for both city driving and long highway journeys. With its bold exterior, premium interior, and advanced infotainment system, the KX1 delivers an enjoyable driving experience for both families and professionals.",

        specifications: {
            Brand: "KIA",
            Model: "KX1",
            BodyType: "Compact SUV",
            Engine: "1.4L Petrol",
            Transmission: "Automatic IVT",
            DriveType: "Front Wheel Drive",
            Power: "100 PS",
            Torque: "132 Nm",
            TopSpeed: "176 km/h",
            FuelType: "Petrol",
            FuelTank: "43 L",
            Mileage: "16-18 km/l",
            Seating: "5 Seater",
            Doors: "5",
            Wheels: "16-inch Alloy Wheels",
            GroundClearance: "185 mm",
            AirConditioning: "Automatic Climate Control"
        },

        exterior: [
            "Signature Tiger Nose Front Grille",
            "Premium LED Headlights",
            "LED Daytime Running Lights",
            "LED Tail Lamps",
            "Front Fog Lamps",
            "Roof Rails",
            "Rear Roof Spoiler",
            "Chrome Door Handles",
            "Body Coloured ORVM",
            "Power Folding Mirrors",
            "16-inch Diamond Cut Alloy Wheels",
            "Shark Fin Antenna",
            "Rear Wiper",
            "Rear Defogger",
            "High Mounted Stop Lamp"
        ],

        interior: [
            "Premium Leather Seats",
            "Leather Wrapped Steering Wheel",
            "Multi Function Steering Wheel",
            "Push Button Start",
            "Smart Key",
            "Automatic Climate Control",
            "Rear AC Vents",
            "Premium Dashboard Finish",
            "Digital Instrument Cluster",
            "Large Touchscreen Infotainment",
            "Adjustable Driver Seat",
            "Split Folding Rear Seats",
            "Ambient Cabin Lighting",
            "Front Arm Rest",
            "Rear Arm Rest",
            "Cup Holders",
            "Power Windows",
            "USB Charging Ports"
        ],

        performance: [
            "1.4L Smart Petrol Engine",
            "Automatic IVT Transmission",
            "Excellent Fuel Efficiency",
            "Smooth City Driving",
            "Comfortable Highway Performance",
            "Responsive Steering",
            "Stable Suspension",
            "Low Noise Cabin",
            "Quick Gear Response",
            "Eco Driving Mode"
        ],

        technology: [
            "8-inch Touchscreen Display",
            "Apple CarPlay",
            "Android Auto",
            "Bluetooth Connectivity",
            "USB Connectivity",
            "Voice Recognition",
            "Steering Mounted Controls",
            "Wireless Smartphone Connectivity",
            "Rear Parking Camera",
            "Parking Sensors",
            "Cruise Control",
            "Digital MID Display"
        ],

        safety: [
            "6 Airbags",
            "ABS",
            "Electronic Brake Distribution",
            "Electronic Stability Control",
            "Hill Start Assist",
            "Traction Control",
            "Rear Parking Sensors",
            "Rear View Camera",
            "Tyre Pressure Monitoring System",
            "ISOFIX Child Seat Mount",
            "Seat Belt Reminder",
            "Engine Immobilizer",
            "Central Locking",
            "Speed Sensing Door Lock",
            "Child Safety Lock"
        ],

        features: [
            "LED Headlights",
            "LED DRLs",
            "Sunroof",
            "16-inch Alloy Wheels",
            "Apple CarPlay",
            "Android Auto",
            "Touchscreen Infotainment",
            "Leather Seats",
            "Cruise Control",
            "Automatic Climate Control",
            "Rear Camera",
            "Rear Parking Sensors",
            "Push Button Start",
            "Wireless Connectivity",
            "ABS + EBD",
            "Electronic Stability Control",
            "Hill Assist",
            "6 Airbags"
        ],

        gallery: [
            "/assets/img/Automobiles/KIA-KX1/1.jpg",
            "/assets/img/Automobiles/KIA-KX1/2.jpg",
            "/assets/img/Automobiles/KIA-KX1/3.jpg",
            "/assets/img/Automobiles/KIA-KX1/4.jpg",
            "/assets/img/Automobiles/KIA-KX1/5.jpg",
            "/assets/img/Automobiles/KIA-KX1/6.jpg",
            "/assets/img/Automobiles/KIA-KX1/7.jpg",
            "/assets/img/Automobiles/KIA-KX1/8.jpg",
            "/assets/img/Automobiles/KIA-KX1/9.jpg",
        ]
    },


];

export default automobiles;